/**
 * Permissions Error Page
 * Displayed when user lacks required SharePoint access or ownership
 */

import { useLocation } from 'react-router-dom';
import StatusScreen, {
  StatusInfoBox,
  StatusPrimaryButton,
} from '../components/layout/StatusScreen';

const LockIcon = (
  <svg
    width='30'
    height='30'
    fill='none'
    stroke='currentColor'
    viewBox='0 0 24 24'
  >
    <path
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={2}
      d='M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z'
    />
  </svg>
);

export default function PermissionsError() {
  const location = useLocation();
  const reason = (location.state as { reason?: string } | null)?.reason;

  return (
    <StatusScreen
      iconBg='#fff7ed'
      iconColor='#ea580c'
      icon={LockIcon}
      title='Access Not Authorized'
      subtitle={
        reason ||
        "You don't have the required permissions to access this portal. You may need to be a site owner or have specific SharePoint permissions."
      }
      actions={
        <StatusPrimaryButton
          full
          onClick={() => {
            window.location.href = '/';
          }}
        >
          Return to Home
        </StatusPrimaryButton>
      }
    >
      <StatusInfoBox title='Common reasons:'>
        <ol
          style={{
            margin: 0,
            paddingLeft: 18,
            display: 'flex',
            flexDirection: 'column',
            gap: 4,
          }}
        >
          <li>
            Not yet added to the SharePoint group that grants portal access
          </li>
          <li>Not a site owner where required</li>
          <li>Access was revoked by administrator</li>
          <li>Organization has not completed setup</li>
        </ol>
      </StatusInfoBox>
      <StatusInfoBox tone='blue' title='Need help?'>
        Ask your SharePoint site owner to add your account to the access group
        for this site. Contact your IT administrator if the issue continues.
      </StatusInfoBox>
    </StatusScreen>
  );
}
